import { useMutation, useQuery } from 'react-query';
import { RecruitmentCitiesService } from '@api/RecruitmentCitiesService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListRecruitmentCities = (
  [page_no, searchText, selectedStatus],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-cities-list', page_no, searchText, selectedStatus],
    RecruitmentCitiesService.listRecruitmentCities,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddRecruitmentCities = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCitiesService.addRecruitmentCities, {
    onSuccess,
    onError
  });
};
// Details
const useViewRecruitmentCities = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-cities-view', () => RecruitmentCitiesService.viewRecruitmentCities(id), {
    onSuccess,
    onError
  });
};
// Details
const useShowRecruitmentCities = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-cities-show', () => RecruitmentCitiesService.showRecruitmentCities(id), {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentCities = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCitiesService.updateRecruitmentCities, {
    onSuccess,
    onError
  });
};
// Delete
const useDeleteRecruitmentCities = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCitiesService.deleteRecruitmentCities, {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentCitiesStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCitiesService.changeStatusRecruitmentCities, {
    onSuccess,
    onError
  });
};
export {
    useListRecruitmentCities,
    useAddRecruitmentCities,
    useViewRecruitmentCities,
    useShowRecruitmentCities,
    useDeleteRecruitmentCities,
    useUpdateRecruitmentCitiesStatus,
    useUpdateRecruitmentCities
};
